import React from "react";
import ReactMarkdown from "react-markdown";
import remarkMath from "remark-math";
import rehypeKatex from "rehype-katex";
import "katex/dist/katex.min.css";

const normalizeDelimiters = (value) => String(value ?? "")
    .replace(/\\\[([\s\S]*?)\\\]/g, (_, math) => `$$${math}$$`)
    .replace(/\\\((.*?)\\\)/g, (_, math) => `$${math}$`);

export function MathText({ children, inline = false, className = "", ...props }) {
    const Wrapper = inline ? "span" : "div";
    return (
        <Wrapper className={`math-content ${className}`} {...props}>
            <ReactMarkdown
                remarkPlugins={[remarkMath]}
                rehypePlugins={[[rehypeKatex, { strict: false, throwOnError: false }]]}
                components={{
                    p: ({ children: content }) => inline
                        ? <span>{content}</span>
                        : <p className="whitespace-pre-wrap [&:not(:first-child)]:mt-2">{content}</p>,
                }}
            >
                {normalizeDelimiters(children)}
            </ReactMarkdown>
        </Wrapper>
    );
}
